import { graphql } from 'gatsby';
import { INLINES } from '@contentful/rich-text-types';
import { Heading } from '~components/Heading';
import { Image } from '~components/Image';
import { RichTextRenderer } from '~components/RichTextRenderer';
import { ComponentLink } from '~components/ComponentLink';

import * as styles from './ComponentCoverageListItem.module.css';

import type { ContentfulComponentCoverageListItem } from './types';

type ComponentCoverageListItemProps = {
  content: Omit<ContentfulComponentCoverageListItem, '__typename'>;
  className?: string;
  style?: React.CSSProperties;
};

export const ComponentCoverageListItem: React.FC<ComponentCoverageListItemProps> = ({
  content: { icon, heading, text },
  className,
  style,
}) => (
  <li className={className} style={style}>
    <Image className={styles.icon} image={icon} />
    {heading && (
      <Heading className={styles.heading} level={2}>
        {heading}
      </Heading>
    )}
    <RichTextRenderer
      content={text.raw}
      wrapperElement='div'
      className={styles.text}
      options={{
        renderNode: {
          [INLINES.EMBEDDED_ENTRY]: ({ data }) => {
            const entry = text.references.find(({ contentful_id }) => data.target.sys.id === contentful_id);
            switch (entry?.__typename) {
              case 'ContentfulComponentLink':
                return <ComponentLink link={entry}>{entry.label}</ComponentLink>;
              default:
                return null;
            }
          },
        },
      }}
    />
  </li>
);

export const query = graphql`
  fragment ComponentCoverageListItem on ContentfulComponentCoverageListItem {
    __typename
    heading
    text {
      raw
      references {
        ...ComponentLink
      }
    }
    icon {
      ...MixedMedia
    }
  }
`;
